const testimonials = [
  {
    title: 'A Game-Changer for Shopping',
    content: 'The LitBuy spreadsheet completely changed how I track prices and find the best deals. I saved over $200 on my last shopping spree just by using the comparison tools recommended here. Absolutely worth checking out if you love smart shopping.',
    author: 'Emily R.',
    role: 'Lifestyle Blogger',
    initials: 'ER',
  },
  {
    title: 'Best Spreadsheet Resource',
    content: 'I was looking for a reliable LitBuy spreadsheet guide and stumbled upon this site. The templates and comparison tables are incredibly well-organized. Makes spreadsheet shopping actually enjoyable rather than overwhelming.',
    author: 'Marcus T.',
    role: 'Budget Enthusiast',
    initials: 'MT',
  },
  {
    title: 'Simple and Effective',
    content: 'As someone who is not tech-savvy, I really appreciated how easy the LitBuy spreadsheet tutorials were to follow. The step-by-step guides made everything crystal clear. Highly recommended for beginners.',
    author: 'Sarah K.',
    role: 'Small Business Owner',
    initials: 'SK',
  },
  {
    title: 'So Many Options, So Easy',
    content: 'The category breakdowns on this site are fantastic. I can quickly jump to exactly what I need without endless scrolling. The LitBuy spreadsheet comparison feature is my go-to tool now.',
    author: 'David L.',
    role: 'Fashion Enthusiast',
    initials: 'DL',
  },
  {
    title: 'Incredibly Helpful Guides',
    content: 'The LitBuy spreadsheet articles here taught me how to organize my shopping data properly. Never thought a spreadsheet could be this powerful for making smarter purchasing decisions.',
    author: 'Jennifer W.',
    role: 'Data Analyst',
    initials: 'JW',
  },
  {
    title: 'My Daily Shopping Companion',
    content: 'I use the LitBuy spreadsheet templates from this site every single day. The layout is intuitive and the links to KasPreadsheet make finding products effortless. A must-bookmark resource.',
    author: 'Alex P.',
    role: 'Online Shopper',
    initials: 'AP',
  },
];

export default function TestimonialSection() {
  return (
    <section className="w-full py-14 md:py-16 bg-secondary-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 rounded-full bg-primary-400"></div>
            <span className="text-xs uppercase tracking-widest text-foreground-500 font-medium">Community Reviews</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            What Our Users Say
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            Real feedback from <strong>LitBuy spreadsheet</strong> users who transformed their shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, idx) => (
            <div
              key={item.author}
              className={`bg-background-50 rounded-2xl p-5 md:p-6 ${
                idx === testimonials.length - 1 ? 'opacity-60' : ''
              }`}
            >
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </div>
                ))}
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">{item.initials}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.author}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}